import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types';
import { newsCategoryLabels } from '@/mocks/news';

interface NewsListItemProps {
  item: NewsItem;
  withCover?: boolean;
}

export default function NewsListItem({ item, withCover = true }: NewsListItemProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-400/60 md:p-4"
    >
      {withCover && (
        <div className="h-24 w-36 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-44">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 配图`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded bg-secondary-500/20 px-2 py-0.5 text-secondary-300">
            {newsCategoryLabels[item.category]}
          </span>
          <span>{item.publishedAt}</span>
        </div>
        <h3 className="mt-2 line-clamp-2 text-base font-semibold leading-snug text-foreground-100 transition-colors group-hover:text-primary-500">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-400">
          {item.subtitle}
        </p>
      </div>
    </Link>
  );
}